export enum FixtureType {
    MATCH = 'match',
    OTHER = 'other',
}